<template>
  <section>
    <div class="left">
      <h2 v-translate>Výběr příjemců</h2>
      <p>
        <translate class="translate">Odhadovaný počet příjemců: </translate>
        {{ numberOfRecipients }} <br/>
      </p>
      <p>
        <translate class="translate">Odhadovaný počet zařízení příjemců: </translate>
        {{ numberOfRecipientsDevices }} <br/>
      </p>
    </div>

    <div class="right">

      <div class="field_left">
        <filter-checkbox
            id="messageSendToAll"
            name="messageSendToAll"
            :pClass="'field send_all'"
            v-model="entity.send_to_all"
            :disabled="!isEditable"
            @input="onSendToAllChange"
        >
          <translate class="translate">Odeslat všem</translate>
        </filter-checkbox>
      </div>

      <div class="field">
        <multiselect-searchbox
            v-if="$_loggedUser_action_allowed('subscribers')"
            :searchFunction="searchSubscribers"
            v-model="entity.recipients.id_subscribers"
            :show-id="true"
            :disabled="disabled"
            @input="onRecipientsChange"
        >{{$gettext('Odběratel')}}</multiselect-searchbox>
        <div class="field_left">
          <filter-checkbox
              id="combineConditions"
              name="combineConditions"
              v-model="entity.combine_recipient_conditions"
              :disabled="disabled"
              :pClass="'field send_all'"
              @input="onRecipientsChange"
          >
            <translate class="translate">Kombinovat následující podmínky</translate>
          </filter-checkbox>
        </div>
        <multiselect-searchbox
            v-if="$_loggedUser_action_allowed('brands')"
            :searchFunction="searchBrands"
            v-model="entity.recipients.id_brands"
            :show-id="true"
            :disabled="disabled"
            @input="onRecipientsChange"
        >{{$gettext('Brand')}}</multiselect-searchbox>
        <multiselect-searchbox
            v-if="$_loggedUser_action_allowed('operators')"
            :searchFunction="searchOperators"
            v-model="entity.recipients.id_operators"
            :show-id="true"
            :disabled="disabled"
            @input="onRecipientsChange"
        >{{$gettext('Operátor')}}</multiselect-searchbox>
        <multiselect-searchbox
            v-if="$_loggedUser_action_allowed('services')"
            :searchFunction="searchServices"
            v-model="entity.recipients.id_services"
            :show-id="true"
            :disabled="disabled"
            @input="onRecipientsChange"
        >{{$gettext('Služba')}}</multiselect-searchbox>
        <multiselect-searchbox
            v-if="$_loggedUser_action_allowed('packages')"
            :searchFunction="searchPackages"
            v-model="entity.recipients.id_channel_packages"
            :show-id="true"
            :disabled="disabled"
            @input="onRecipientsChange"
        >{{$gettext('Balíček kanálů')}}</multiselect-searchbox>
        <multiselect-searchbox
            v-if="$_loggedUser_action_allowed('deviceTypes')"
            :searchFunction="searchDeviceTypes"
            v-model="entity.recipients.device_type_codes"
            :show-id="true"
            :disabled="disabled"
            @input="onRecipientsChange"
        >{{$gettext('Typ zařízení')}}</multiselect-searchbox>
        <div class="field_left" v-if="$_loggedUser_action_allowed('subscribers')">
          <select-box id="subscriberType"
                      v-model="entity.recipients.subscriber_type"
                      :disabled="disabled"
                      :options="subscriberTypes"
                      ref="subscribertyperef"
                      @input="onRecipientsChange"
          >
            <translate class="translate">Typ odběratele</translate>
          </select-box>
          <p></p>
        </div>
        <multiselect-searchbox
            v-if="$_loggedUser_action_allowed('tags')"
            :searchFunction="searchTags"
            v-model="entity.recipients.id_subscriber_tags"
            :show-id="true"
            :disabled="disabled"
            @input="onRecipientsChange"
        >{{$gettext('Štítky odběratele')}}</multiselect-searchbox>
      </div>
    </div>
  </section>
</template>

<script>
import advertisingBanners from "./../mixins/advertisingBanners";

export default {
  name: "AdvertisingBannerRecipientsForm",
  components: {},
  mixins: [advertisingBanners],
  props: {
    entity: Object,
    isUpdate: Boolean,
    isEditable: Boolean,
  },
  created: function (AdvertisingBannerService, OperatorService, SubscriberService,
                     ServiceService, PackageService, DeviceService,
                     MessageTemplateService, BrandService, TagService) {
    this.advertisingBannerService = AdvertisingBannerService;
    this.operatorService = OperatorService;
    this.serviceService = ServiceService;
    this.packageService = PackageService;
    this.subscriberService = SubscriberService;
    this.deviceService = DeviceService;
    this.messageTemplateService = MessageTemplateService;
    this.brandService = BrandService;
    this.tagService = TagService;

    this.subscriberService.getSubscriberTypeList({'id_operator': null})
        .then(data => {
          this.subscriberTypes = [{id: null, text: this.$gettext('Není vybrán')},]
          this.subscriberTypes = this.subscriberTypes.concat(data.subscriber_types)
        }).then(() => {
          this.onRecipientsChange();
    });
  },
  data(){
    return {
      numberOfRecipients: 0,
      numberOfRecipientsDevices: 0,
      subscriberTypes: [],
    }
  },
  computed: {
    disabled(){
      return !this.isEditable || this.entity.send_to_all;
    }
  },
  methods: {
    searchBrands(search, selectAll=false) {
      return this.brandService.searchBrandsForRecipients({search: search, select_all: selectAll});
    },
    searchOperators(search, selectAll=false) {
      return this.operatorService.searchOperatorsForRecipients({search: search, select_all: selectAll});
    },
    searchDeviceTypes(search, selectAll=false) {
      return this.deviceService.searchDeviceTypesForRecipients({search: search, select_all: selectAll});
    },
    searchPackages(search, selectAll=false) {
      return this.packageService.searchPackagesByNameOrId({search: search, selected_operator: this.$_loggedUser_selectedOperatorId, select_all: selectAll});
    },
    searchServices(search, selectAll=false) {
      return this.serviceService.searchServicesByNameOrId({search: search, id_selected_operator: this.$_loggedUser_selectedOperatorId, select_all: selectAll});
    },
    searchSubscribers(search, selectAll=false) {
      return this.subscriberService.searchSubscribers({search: search, selected_operator: this.$_loggedUser_selectedOperatorId, select_all: selectAll});
    },
    searchTags(search, selectAll=false) {
      return this.tagService.searchTagByNameAndOperatorId(this.$_loggedUser_selectedOperatorId ? this.$_loggedUser_selectedOperatorId : 0, {name_search: search, select_all: selectAll});
    },
    onRecipientsChange() {
      if (!this.entity.send_to_all) {
        this.advertisingBannerService.getRecipients({
          combine_recipient_conditions: this.entity.combine_recipient_conditions,
          recipients: this.entity.recipients,
          device_group_settings: this.entity.device_group_settings,
          send_to_all: this.entity.send_to_all,
        }).then(data => {
          this.numberOfRecipients = data.counts.recipients;
          this.numberOfRecipientsDevices = data.counts.recipients_devices;
        })
      }else {
        this.numberOfRecipients = this.$gettext('Všichni');
        this.numberOfRecipientsDevices = this.$gettext('Všechna');
      }
    },
    onSendToAllChange(){
      this.entity.recipients = {
        id_subscribers: [],
            id_brands: [],
            id_operators: [],
            id_services: [],
            id_channel_packages: [],
            device_type_codes: [],
            subscriber_type: null,
            id_subscriber_tags: [],
      };
      this.onRecipientsChange();
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Forms/Recipients.vue